import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import AddchartIcon from '@mui/icons-material/Addchart';
import AddHomeIcon from '@mui/icons-material/AddHome';
import DI from '../../../utility/DI';

function FloatingAdd(props) {
  const {
    di: { session,},
  } = props;
  return (
  <div id="floating-add-buttons" style={{position:'fixed',bottom:'3vh',right:'20px'}}>
      <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <Tooltip title="Add Shared Expense" placement="left" arrow>
        <Fab color="secondary" aria-label="add shared expense" onClick={()=>props.onclick('shared_expense')}>
          <AddchartIcon/>
        </Fab>
      </Tooltip>
      <Tooltip title="Add Home Expense" placement="left" arrow>
        <span>
          <Fab color="warning" aria-label="add home expense" disabled={!session?.homes?.length} onClick={()=>props.onclick('home_expense')}>
            <AddHomeIcon />
          </Fab>
        </span>
      </Tooltip>
    </Box>
  </div>
  );
}
export default DI(FloatingAdd)